export default __webpack_public_path__ + "static/media/r19.177d1582.jpg";